
    import './styles.scoped.css';
    export default {
  "dimmed": "awsui_dimmed_10ipo_cvg2s_5",
  "root": "awsui_root_10ipo_cvg2s_27",
  "list": "awsui_list_10ipo_cvg2s_37",
  "list-item": "awsui_list-item_10ipo_cvg2s_44",
  "key": "awsui_key_10ipo_cvg2s_49"
};
  